import { getTokenManager } from "@Auth/session";
import { useUserContext } from "@Hooks/contexts/useUserContext";
import { styled } from "@mui/material/styles";
import { Button, EmptyState, LockIcon, Logo, Meta, TopBar } from "@UI";
import React from "react";
import { useTranslation } from "react-i18next";
const Root = styled("div")({
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    "& .access-signed-in": {
        display: "block",
        textAlign: "center",
        padding: "0 var(--j-sp-6) var(--j-sp-4)"
    }
});
const Brand = styled("span")({
    display: "flex",
    paddingLeft: "var(--j-sp-1)",
    marginTop: "var(--j-sp-1)",
    color: "var(--j-ink)"
});
export function AccessRequired() {
    const { t } = useTranslation();
    const email = useUserContext((s)=>s.user?.email);
    const handleLogout = async ()=>{
        await getTokenManager().signOut();
        localStorage.clear();
        window.location.reload();
    };
    return /*#__PURE__*/ React.createElement(Root, null, /*#__PURE__*/ React.createElement(TopBar, null, /*#__PURE__*/ React.createElement(Brand, null, /*#__PURE__*/ React.createElement(Logo, {
        height: 20
    }))), /*#__PURE__*/ React.createElement(EmptyState, {
        icon: /*#__PURE__*/ React.createElement(LockIcon, null),
        tone: "neutral",
        size: "lg",
        title: t("shell.access.title"),
        text: t("shell.access.text"),
        stackActions: true,
        actions: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Button, {
            size: "lg",
            onClick: ()=>window.location.reload()
        }, t("shell.access.checkAgain")), /*#__PURE__*/ React.createElement(Button, {
            size: "lg",
            variant: "outline",
            onClick: handleLogout
        }, t("logout")))
    }), email && /*#__PURE__*/ React.createElement(Meta, {
        className: "access-signed-in"
    }, t("shell.access.signedInAs", {
        email
    })));
}
